"use client";

import dynamic from "next/dynamic";

// Loaded off the server render (and out of the layout's initial chunk): the
// bridge only acts after Clerk has resolved a signed-in user.
const GlobalAccountConsentBridge = dynamic(
  () =>
    import("@/components/analytics/global-account-consent-bridge").then(
      (module) => ({ default: module.GlobalAccountConsentBridge }),
    ),
  { ssr: false },
);

/** Rendered once, inside `ClerkScope` (components/auth/clerk-scope.tsx). */
export function DeferredAccountConsentBridge() {
  return <GlobalAccountConsentBridge />;
}
